import React from "react";
import { CARD_PROPS } from "./interface";
import { CardDiv } from "./CardStyled";

export default function Card({
  children,
  func,
  width,
  height,
  background,
  size,
  suitColor,
  suitSize,
  customClass,
  pad,
  marg,
  corner,
  primaryAnim,
  secondaryAnim,
  customProp,
  shadow,
  lineHeight,
}: CARD_PROPS) {
  return (
    <CardDiv
      width={width}
      height={height}
      background={background}
      size={size}
      suitSize={suitSize}
      suitColor={suitColor}
      className={customClass}
      customProp={customProp}
      pad={pad}
      marg={marg}
      corner={corner}
      primaryAnim={primaryAnim}
      secondaryAnim={secondaryAnim}
      shadow={shadow}
      lineHeight={lineHeight}
    >
      {children}
    </CardDiv>
  );
}
